import React from 'react';
import { FormYesNoChoice } from './FormYesNoChoice';

/**
 * @deprecated Prefer {@link FormYesNoChoice} directly in new code.
 * Thin wrapper so legacy imports stay aligned with radio Yes/No UX (no dropdown / modal).
 */
export interface YesNoSelectorProps {
  label: string;
  value: string;
  onSelect: (value: string) => void;
  /** Ignored — radios do not use a blank placeholder row. */
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  helperText?: string;
  containerStyle?: object;
}

export const YesNoSelector: React.FC<YesNoSelectorProps> = ({
  label,
  value,
  onSelect,
  required = false,
  disabled = false,
  error,
  helperText,
  containerStyle,
}) => (
  <FormYesNoChoice
    label={label}
    value={value}
    onSelect={(v) => onSelect(v)}
    required={required}
    disabled={disabled}
    error={error}
    helperText={helperText}
    containerStyle={containerStyle}
  />
);
